<template>
    <div class="pl-4 pr-4 pb-4">
        <v-row class="align-center mb-0 mt-2">
            <v-col>
                <h2 class="ma-0">Edit job</h2>
            </v-col>
            <v-col class="text-right"><v-icon color="primary" @click="close">mdi-close</v-icon></v-col>
        </v-row>
        <v-row no-gutters v-if="newItem.status">
            <!-- {{ newItem }} -->
            <v-col>
                <v-card v-if="isPendingApproval" class="mb-8">
                  <v-card-title><h3 class="ma-0">Review job submission</h3></v-card-title>
                  <v-card-text
                    >This is a user submitted job posting. Please review the job post
                    details and accept or decline it. This will send a confirmation email to the email of the contact person.</v-card-text
                  >
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="acceptJob()"
                      >Accept job</v-btn
                    >
                    <v-btn color="error" text @click="declineDialog = true"
                      >Decline</v-btn
                    >
                  </v-card-actions>
                </v-card>

                <v-dialog v-model="declineDialog" max-width="360">
                  <v-card>
                    <v-card-title class="headline">
                      Select reason to decline
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-checkbox
                          v-for="reason in reasonsToHide"
                          :label="reason.description"
                          :value="reason.id"
                          :key="reason.id"
                          v-model="selectedReasonsToHide"
                          hide-details
                        ></v-checkbox>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>

                      <v-btn text @click="declineDialog = false">
                        Cancel
                      </v-btn>

                      <v-btn color="error" text @click="declineJob()">
                        Confirm
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-dialog v-model="deleteDialog" max-width="360">
                  <v-card>
                    <v-card-title class="headline">
                      Confirm deletion
                    </v-card-title>

                    <v-card-text>
                      Are you sure you want to delete this job?
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>

                      <v-btn text @click="deleteDialog = false">
                        Cancel
                      </v-btn>

                      <v-btn color="error" text @click="deleteJob()">
                        Delete
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <div class="mb-6">
                  <div class="text-caption">Source</div>
                  <v-chip label small>{{newItem.source.apiId}}</v-chip>
                </div>

                <v-text-field
                  v-model="newItem.title"
                  label="Job title"
                  placeholder="Enter job title"
                  outlined
                  hide-details
                  class="mb-4"
                ></v-text-field>

                <v-dialog
                  v-model="descriptionDialog"
                  width="600"
                  scrollable
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      elevation="0"
                      class="mb-5 ml-2"
                      :href="newItem.externalUrl"
                      target="_blank">
                      <v-icon small left>mdi-open-in-new</v-icon>
                      Visit website
                    </v-btn>
                    <v-btn
                      small
                      elevation="0"
                      v-bind="attrs"
                      v-on="on"
                      class="mb-5">
                      <v-icon small left>mdi-file-eye-outline</v-icon>
                      View job description
                    </v-btn>
                  </template>

                  <v-card>
                    <v-card-title class="b-b">
                      <v-row>
                        <v-col cols="10">
                          <h4 class="ma-0">{{newItem.title}}</h4>
                          <div class="text-caption">
                            {{ newItem.employer.name }},
                            {{ newItem.location.city ? newItem.location.city : newItem.location.area }}
                          </div>
                        </v-col>
                        <v-col cols="2" class="text-right">
                          <v-btn
                            icon
                            @click="descriptionDialog = false"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-title>

                    <v-card-text>
                      <div v-html="renderedDescription" class="mt-2"></div>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        text
                        @click="descriptionDialog = false"
                      >
                        Close
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-select
                  v-model="selectedReasonsToHide"
                  :items="reasonsToHide"
                  label="Reasons to hide"
                  item-text="description"
                  item-value="id"
                  multiple
                  chips
                  outlined
                  dense
                  small-chips
                  :menu-props="{ offsetY: true }"
                ></v-select>

                <v-select
                  v-model="selectedCategories"
                  :items="categories"
                  label="Categories"
                  multiple
                  chips
                  outlined
                  dense
                  small-chips
                  item-text="name"
                  item-value="id"
                  :menu-props="{ offsetY: true }"
                ></v-select>

                <v-combobox
                  v-model="selectedTags"
                  :items="tags"
                  label="Tags"
                  multiple
                  chips
                  outlined
                  dense
                  small-chips
                ></v-combobox>

                <h3>Employer details</h3>

                <v-combobox
                  required
                  v-model="selectedEmployer"
                  :items="employers"
                  label="Employer name"
                  placeholder="Select existing or create a new organisation"
                  outlined
                  item-text="name"
                ></v-combobox>

                <v-text-field
                  v-model="newItem.employer.externalUrl"
                  label="Link to website"
                  placeholder="https://"
                  outlined
                ></v-text-field>

                <v-text-field
                  v-model="newItem.employer.careersUrl"
                  label="Link to careers page"
                  placeholder="https://"
                  outlined
                ></v-text-field>

                <v-text-field
                  v-model="newItem.employer.imageUrl"
                  label="Logo URL"
                  placeholder="https://"
                  outlined
                ></v-text-field>

                <h3>Job details</h3>

                <v-text-field
                  v-model="newItem.source.contactEmail"
                  label="Contact email"
                  outlined
                ></v-text-field>

                <v-text-field
                  v-model="newItem.location.city"
                  label="City"
                  placeholder="Enter city or cities"
                  outlined
                  dense
                ></v-text-field>

                <v-select
                  v-model="newItem.location.area"
                  :items="areas"
                  label="Region"
                  outlined
                  dense
                  item-text="text"
                  item-value="text"
                  :menu-props="{ offsetY: true }"
                ></v-select>

                <v-menu
                  v-model="publishMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="publishDate"
                      label="Publish job posting"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      outlined
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    required
                    v-model="publishDate"
                    @input="publishMenu = false"
                  ></v-date-picker>
                </v-menu>

                <v-menu
                  v-model="expiresMenu"
                  ref="expiresMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="expireDate"
                      label="Job posting expires on"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      outlined
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    required
                    v-model="expireDate"
                    @input="expiresMenu = false"
                  ></v-date-picker>
                </v-menu>

                <div v-if="campaigns.length > 0" class="mb-6">
                  <label class="mb-2">Campaigns</label>
                  <v-chip
                    v-for="campaign in campaigns"
                    :key="campaign.id"
                    class="mb-2 mr-2"
                  >
                    {{ campaign.title }}
                  </v-chip>
                </div>

                <div v-if="isPendingApproval">
                  <h3>Review job</h3>
                  <v-btn
                    width="100%"
                    class="primary"
                    large
                    @click="acceptJob()"
                    >Accept job</v-btn
                  >
                  <v-btn
                    color="error"
                    outlined
                    width="100%"
                    class="mt-4"
                    large
                    @click="declineJob()"
                    >Decline job</v-btn
                  >
                </div>

                <div v-if="!isPendingApproval">
                  <v-btn
                    :loading="isSaving"
                    width="100%"
                    class="primary"
                    large
                    @click="save()"
                    >Save</v-btn
                  >
                  <v-btn
                    color="error"
                    outlined
                    width="100%"
                    class="mt-4"
                    large
                    @click="deleteDialog = true"
                    >Delete</v-btn
                  >
                </div>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import jwt_decode from 'jwt-decode';

export default {
  name: 'JobEditor',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      publishMenu: false,
      expiresMenu: false,
      newItem: {},
      oldItem: {},
      campaigns: [],
      isSaving: false,
      declineDialog: false,
      deleteDialog: false,
      descriptionDialog: false
    };
  },
  // Watch for changes to the item prop
  watch: {
    item: {
      handler(item) {
        this.newItem = JSON.parse(JSON.stringify(item));
        this.oldItem = JSON.parse(JSON.stringify(item));
      },
      deep: true,
      immediate: true,
    },
  },
  async mounted() {
    await this.$store.dispatch('dispatchGetEmployers');

    await this.$store.dispatch('dispatchGetCampaignsWithJobs').then((campaigns) => {
      this.campaignItems = campaigns;
      this.campaigns = campaigns.filter(c => (
        c.jobs.findIndex(job => job.id === this.newItem.id) > -1
      ));
    });
  },
  computed: {
    areas() {
      return this.$store.state.mapData.map(area => ({
        text: area.name, value: area.id,
      }));
    },
    selectedAreas: {
      // eslint-disable-next-line object-shorthand, func-names
      get: function () {
        return this.item.areas.map(area => ({ value: area.id, text: area.name }));
      },
      // eslint-disable-next-line object-shorthand, func-names
      set: function (val) {
        console.log(val);
        this.item.areas = val.map(area => ({ id: area.value, name: area.text }));
      },
    },
    reasonsToHide() {
      return this.$store.state.reasonsToHideAdmin;
    },
    categories() {
      return this.$store.state.categoriesWithDetails;
    },
    tags() {
      return this.$store.state.tags;
    },
    employers() {
      return this.$store.state.employers.employers;
    },
    selectedReasonsToHide: {
      // eslint-disable-next-line object-shorthand, func-names
      get: function () {
        return Object.keys(this.newItem.status.hiddenBecause);
      },
      // eslint-disable-next-line object-shorthand, func-names
      set: function (val) {
        this.newItem.status.hiddenBecause = {};
        val.forEach((reason) => {
          this.newItem.status.hiddenBecause[reason] = true;
        });
      },
    },
    selectedCategories: {
      // eslint-disable-next-line object-shorthand, func-names
      get: function () {
        return this.newItem.clustering.categories.map(category => category.id);
      },
      // eslint-disable-next-line object-shorthand, func-names
      set: function (val) {
        this.newItem.clustering.categories = [];
        val.forEach((category) => {
          this.newItem.clustering.categories.push({ id: category, confidence: 1 });
        });
      },
    },
    selectedTags: {
      // eslint-disable-next-line object-shorthand, func-names
      get: function () {
        return this.newItem.clustering.tags ? this.newItem.clustering.tags.map(tag => tag.id) : [];
      },
      // eslint-disable-next-line object-shorthand, func-names
      set: function (val) {
        this.newItem.clustering.tags = [];
        val.forEach((tag) => {
          this.newItem.clustering.tags.push({ id: tag, confidence: 1 });
        });
      },
    },
    selectedEmployer: {
      // eslint-disable-next-line object-shorthand, func-names
      get: function () {
        return this.newItem.employer;
      },
      // eslint-disable-next-line object-shorthand, func-names
      set: function (value) {
        if (typeof value === 'object') {
          // Existing employer
          this.newItem.employer = value;
          delete this.newItem.employer.id;
        } else {
          // New employer
          this.newItem.employer.name = value;
          this.newItem.employer.source = 'jobsinfinland.fi-v1.0';
        }
      },
    },
    isPendingApproval() {
      return (
        this.newItem.status.reviewStatus !== 'human'
        && this.newItem.status.hiddenBecause.userSubmitted
      );
    },
    publishDate: {
      // eslint-disable-next-line object-shorthand, func-names
      get: function () {
        return this.newItem.schedule.publish.split('T')[0];
      },
      // eslint-disable-next-line object-shorthand, func-names
      set: function (value) {
        this.newItem.schedule.publish = new Date(value).toISOString();
      },
    },
    expireDate: {
      // eslint-disable-next-line object-shorthand, func-names
      get: function () {
        return this.newItem.schedule.expire.split('T')[0];
      },
      // eslint-disable-next-line object-shorthand, func-names
      set: function (value) {
        this.newItem.schedule.expire = new Date(value).toISOString();
      },
    },
    renderedDescription() {
      return this.newItem.description.replace(/(?:\r\n|\r|\n)/g, '<br>');
    },
  },
  methods: {
    async save(saveAction = 'modify') {
      const decodeToken = jwt_decode(this.$store.state.JWT);
      const userId = decodeToken.sub;
      const reviewer = await this.$store.dispatch('dispatchGetUser', { userId });

      console.log(reviewer);

      // Create payload
      const jobData = {
        id: this.newItem.id,
        title: this.newItem.title,
        description: this.newItem.description,
        imageUrl: this.newItem.imageUrl,
        externalUrl: this.newItem.externalUrl,
        employer: this.newItem.employer,
        location: this.newItem.location,
        source: this.newItem.source,
        schedule: this.newItem.schedule,
        clustering: this.newItem.clustering,
        status: { ...this.newItem.status, reviewStatus: 'human' },
      };

      this.isSaving = true;
      this.$store.dispatch('dispatchPutAdminJob', {
        jobId: this.newItem.id,
        jobData,
        reviewerData: reviewer,
      }).then(() => {
        this.isSaving = false;
        this.$emit('saved');
      }).catch((error) => {
        this.isSaving = false;
        console.error(error);
      });

      // Send review notifications
      // eslint-disable-next-line default-case
      switch (saveAction) {
        case 'acceptJob':
          await this.$store
            .dispatch('dispatchPostAdminAcceptJob', { jobData, reviewerData: reviewer });
          break;
        case 'declineJob':
          await this.$store
            .dispatch('dispatchPostAdminDeclineJob', { jobData, reviewerData: reviewer });
          break;
      }
    },
    acceptJob(accept = true) {
      if (accept) {
        // Job accepted
        this.newItem.status.reviewStatus = 'human';
        this.newItem.status.hiddenBecause = {};
        this.selectedReasons = [];

        this.save('acceptJob');
      } else {
        // Job declined
        this.declineDialog = false;
        this.newItem.status.reviewStatus = 'human';

        this.save('declineJob');
      }
    },
    declineJob() {
      this.save('declineJob');
    },
    deleteJob() {
      this.deleteDialog = false;
      this.newItem.status.hiddenBecause = { deleted: true };
      this.newItem.status.publicationStatus = 'hidden';

      this.save('deleteJob');
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style></style>
